import type { ZudokuConfig } from "zudoku";
import { apis } from "./apis";
import { Mermaid } from "./src/components/mermaid";
import { theme } from "./theme";

const config: ZudokuConfig = {
  theme,
  site: {
    logo: {
      src: {
        light: "/logo-light.png",
        dark: "/logo-dark.png",
      },
      alt: "Developer Portal",
      width: "320px",
    },
  },
  authentication: {
    type: "openid",
    clientId: "0oaq8ubp1fG291gUW5d7",
    issuer: "https://autodistribution-ang.okta.com/oauth2/aus27t7xp9OCinWn85d7",
    scopes: ["openid", "profile", "email"],
  },
  protectedRoutes: [
    "/sdks/*",
    "/guides/*",
    "/changelog/*",
    "/catalog/*",
    "/specs/*",
  ],
  search: {
    type: "pagefind",
    // Optional: Maximum number of sub results per page
    maxSubResults: 3,
    // Optional: Configure search result ranking (defaults shown below)
    ranking: {
      termFrequency: 0.8,
      pageLength: 0.6,
      termSimilarity: 1.2,
      termSaturation: 1.2,
    },
  },
  mdx: {
    components: {
      Mermaid,
    },
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: [
        {
          type: "category",
          label: "Getting Started",
          icon: "sparkles",
          items: ["/introduction", "/info/authentication"],
        },
        {
          type: "category",
          label: "Additional Information",
          items: ["/info/metadata", "/info/error-responses"],
        },
        {
          type: "category",
          label: "Useful Links",
          collapsible: false,
          icon: "link",
          items: [
            {
              type: "link",
              icon: "book",
              label: "Restful API Guidelines",
              to: "https://developer.autossimo.com/restful-api-guidelines/",
            },
            {
              type: "link",
              icon: "book",
              label: "Problem Details Registry",
              to: "/problem-details/introduction",
            },
          ],
        },
      ],
    },
    {
      type: "link",
      to: "/catalog",
      label: "API Catalog",
      icon: "boxes",
    },
    {
      type: "category",
      icon: "book-open",
      label: "Guides",
      items: [
        "/guides/overview",
        "/guides/identify-vehicle-by-registration-plate",
        "/guides/get-repair-times-for-a-vehicle",
        "/guides/get-oem-parts-for-a-vehicle-category",
        "/guides/check-availability-and-price",
        "/guides/create-and-track-an-order",
      ],
    },
    {
      type: "category",
      icon: "library-big",
      label: "SDKs & Libraries",
      items: ["/sdks/overview"],
    },
    {
      type: "category",
      icon: "megaphone",
      label: "Changelog",
      items: ["/changelog/introduction"],
    },
  ],
  redirects: [{ from: "/", to: "/introduction" }],
  catalogs: {
    path: "/catalog",
    label: "API Catalog",
  },
  apis,
};

export default config;
